










































import { Component, Vue, Watch } from "vue-property-decorator";
import { apiService, Interfaces, AppConstants } from "@/core/Export";
import EmployeeSummaryView from "@/components/EmployeeSummaryView.vue";
import store from "@/store";

@Component({
  components: { EmployeeSummaryView }
})
export default class EmployeeSummary extends Vue {
  summary: any;

  constructor() {
    super();
    this.summary = {
      regularHoursText: null,
      hoserHoursText: null,
      quotasSummary: { groups: [] }
    };
  }

  created() {
    this.onGetEmployeeAttendMonthMinSummary();
  }

  @Watch("selectedYear")
  @Watch("selectedMonth")
  onGetEmployeeAttendMonthMinSummary() {
    this.appEnv.isBusy = true;
    apiService
      .getEmployeeAttendMonthMinSummary(this.currentEmployee.id, this.selectedYear, this.selectedMonth, this.selectedEmpNominationId)
      .then(res => {
        let result: Interfaces.iServiceRequest = res;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.summary = call.callResult.data;
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
      })
      .catch(err => {
      })
      .finally(() => {
        this.appEnv.isBusy = false;
      });
  }

  onCloseEmployeeSummaryDrawer() {
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, false);
    store.commit(AppConstants.StoreMutations.UpdateLeftDrawerComponnent, null);
    store.commit(AppConstants.StoreMutations.UpdateDrawerParams, {});
  }

  public get selectedEmpNominationId(): number {
    return store.state.selectedEmpNominationId;
  }

  get drawerParams() {
    return store.getters.drawerParams;
  }

  get currentEmployee() {
    return store.getters.currentEmployee;
  }

  get selectedYear() {
    return store.getters.selectedYear;
  }

  get selectedMonth() {
    return store.getters.selectedMonth;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
